import React, { useEffect, useState } from "react";
import { categoriesOrder } from "../vars/orderLists";
import catalogueContext from "./CatalogueContext";

const CatalogueContextProvider = ({ children }) => {
  const [options, setOptions] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch("https://ozparts2.usermd.net/api/external/applications", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        action: "getApplications",
        language: "polish",
        source: "pedderspl",
        manufacturergroup: "5f9bda55dcdf6b0c04f1878b",
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.options?.make) {
          setOptions([...new Set(responseJson.options.make.sort())]);
          setCategories([
            ...new Set(
              responseJson.options.categorydescription
                .map((obj) => (obj === "" ? "OTHER" : obj.toUpperCase()))
                .sort(
                  (a, b) =>
                    categoriesOrder.indexOf(a) - categoriesOrder.indexOf(b)
                )
            ),
          ]);
        }
      });
  }, []);

  return (
    <catalogueContext.Provider value={{ options, categories }}>
      {children}
    </catalogueContext.Provider>
  );
};

export default CatalogueContextProvider;
